import classNames from 'classnames';
import * as React from 'react';

export type NoticeTone = 'info';

export interface NoticeProps extends React.HTMLAttributes<HTMLParagraphElement> {
    tone?: NoticeTone;
}

const toneClasses: Record<NoticeTone, string> = {
    info: 'mp-notice--info',
};

export const Notice: React.FunctionComponent<NoticeProps> = ({tone = 'info', className, children, ...rest}: NoticeProps) => (
    <p className={classNames('mp-notice', toneClasses[tone], className)} {...rest}>
        {children}
    </p>
);
